<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :class="extraInfo"
          :id="id"
          v-model="date"
          :label="label"
          :value="value"
          :error="errorMessages && errorMessages.length > 0"
          :error-messages="errorMessages"
          :disabled="disabled"
          :clearable="!readOnly"
          readonly
          :prepend-inner-icon="$getIcon('mdiCalendar')"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-if="!readOnly"
        v-model="date"
        :type="type"
        no-title
        @input="$refs.menu.save(date)"
      ></v-date-picker>
    </v-menu>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    extraInfo: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "date"
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: [String, Array],
      default() {
        return [];
      }
    },
    errorMessages: {
      type: [String, Array],
      default() {
        return [];
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menu: false,
      date: this.value
    };
  },
  watch: {
    value(val) {
      this.date = val;
    },
    async date(val) {
      await this.$emit("input", val);
      if (val) await this.$emit("blur");
    }
  }
};
</script>
